import { Button, IconButton, Typography } from "@bonusx-global/bx-design-system";
import { TimesSolid } from "@bonusx-global/bx-icons";
import { useCallback } from "react";
import * as rdd from "react-device-detect";
import bonusxIcon from "../../../assets/image/icon-bonusx.svg";
import {
  BRAND_APP_ANDROID_DESCRIPTION,
  BRAND_APP_IOS_DESCRIPTION,
  BRAND_NAME,
  USE_THE_APP,
} from "../../../constants/commonStrings";
import { useMobileAppBannerStore } from "../../hooks/useMobileAppBannerStore";
import {
  MOBILE_APP_BANNER_ICON_SIZE,
  MobileAppBannerIconWrapper,
  MobileAppBannerInner,
  MobileAppBannerWrapperElement,
} from "./components/mobile-app-banner.components";

export const MOBILE_APP_BANNER_ID = "mobile-app-banner";
export const MOBILE_APP_BANNER_ICON_ID = `${MOBILE_APP_BANNER_ID}-icon`;

function MobileAppBanner(): JSX.Element | null {
  const { setBannerIsNotVisible } = useMobileAppBannerStore();

  function closeBanner(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    event.stopPropagation();
    setBannerIsNotVisible();
  }

  const onOpenStoreCallback = useCallback(() => {
    openAppStoreLink();
    setBannerIsNotVisible();
  }, [setBannerIsNotVisible]);

  const onCloseCallback = useCallback(closeBanner, [setBannerIsNotVisible]);

  return (
    <MobileAppBannerWrapperElement data-testid={MOBILE_APP_BANNER_ID} onClick={onOpenStoreCallback}>
      <MobileAppBannerInner>
        <IconButton size="small" onClick={onCloseCallback}>
          <TimesSolid />
        </IconButton>
        <MobileAppBannerIconWrapper>
          <img
            src={bonusxIcon}
            data-testid={MOBILE_APP_BANNER_ICON_ID}
            alt="mobile-app-banner-bonusx-icon"
            width={MOBILE_APP_BANNER_ICON_SIZE}
            height={MOBILE_APP_BANNER_ICON_SIZE}
          />
        </MobileAppBannerIconWrapper>
        <div>
          <Typography css={{ lineHeight: 1.3 }} variant="subtitle1">
            {BRAND_NAME}
          </Typography>
          <Typography css={{ lineHeight: 1 }} variant="body2" color="textSecondary">
            {rdd.isAndroid ? BRAND_APP_ANDROID_DESCRIPTION : BRAND_APP_IOS_DESCRIPTION}
          </Typography>
        </div>
      </MobileAppBannerInner>
      <div>
        <Button size="small">{USE_THE_APP}</Button>
      </div>
    </MobileAppBannerWrapperElement>
  );
}

export default MobileAppBanner;

const APP_STORE_LINK = "https://apps.apple.com/app/id6483363564";
const GOOGLE_PLAY_STORE_LINK = "https://play.google.com/store/apps/details?id=it.bonusx.app.prod";

function openAppStoreLink() {
  window.open(rdd.isAndroid ? GOOGLE_PLAY_STORE_LINK : APP_STORE_LINK);
}
